export { default as CoverImage } from './CoverImage';



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/CoverImage/index.ts